
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/InnerLayout.js';
import * as General from '../General/General.js';
import * as ReactDOM from 'react-router-dom';
import PN from 'persian-number'
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { Interweave } from "interweave";
import * as BiIcon from "react-icons/bi";
import { Carousel } from 'react-bootstrap';
import AddBasketItem from "../Basket/AddBasketItem.js"
import { Helmet } from "react-helmet";
import axios from 'axios';


const ProductInfo = () => {

    //#region Const 
    const navigate = ReactDOM.useNavigate();
    let { Group } = ReactDOM.useParams();
    let { Parent } = ReactDOM.useParams();
    let { Product } = ReactDOM.useParams();
    // let { GroupId } = ReactDOM.useParams();
    // let { ParentId } = ReactDOM.useParams();
    // let { Id } = ReactDOM.useParams();
    const toaster = rsuite.useToaster();
    const [PropertyList, setPropertyList] = React.useState([]);
    const [GroupRelativeList, setGroupRelativeList] = React.useState([]);
    const [BrandRelativeList, setBrandRelativeList] = React.useState([]);
    const [Comment, setComment] = React.useState();
    const [seoTitle, setseoTitle] = React.useState();
    const [seoDescription, setseoDescription] = React.useState();
    const [Canonical, setCanonical] = React.useState();
    const [PhotoList, setPhotoList] = React.useState([]);
    const [Power, setPower] = React.useState(0);
    const [Current, setCurrent] = React.useState(0);
    const [Price, setPrice] = React.useState(0);
    const [SaleCount, setSaleCount] = React.useState(0);
    const [Brand, setBrand] = React.useState("");
    const [GroupId, setGroupId] = React.useState(0);
    const [ParentId, setParentId] = React.useState(0);
    const [BrandId, setBrandId] = React.useState(0);
    const [IdentityNo, setIdentityNo] = React.useState(0);
    const [PhotoTag, setPhotoTag] = React.useState("");
    const [ProductType, setProductType] = React.useState("");
    const [Discount, setDiscount] = React.useState(0);
    const [FinalPrice, setFinalPrice] = React.useState(0);
    const [HasCatalog, setHasCatalog] = React.useState(0);
    const [Count, setCount] = React.useState(0);
    const [SaleType, setSaleType] = React.useState(0);
    const [PhotoURLName, setPhotoURLName] = React.useState("");
    const [Id, setId] = React.useState(localStorage.getItem("ProductId"));
    const [background, setbackground] = React.useState("");
    const [PGroup, setPGroup] = React.useState("");
    const [PProduct, setPProduct] = React.useState("");
    const [PParent, setPParent] = React.useState("");
    const [GroupURL, setGroupURL] = React.useState("");
    const [ParentURL, setParentURL] = React.useState("");
    const [Unit, setUnit] = React.useState("");
    const [SRIID, setSRIID] = React.useState(General.GuidEmpty());
    const [BasketItemId, setBasketItemId] = React.useState(General.GuidEmpty());

    const [ProductSchema, setProductSchema] = React.useState({})
    const [BreadcrumbSchema, setBreadcrumbSchema] = React.useState(null);

    const BindBasket = () => {
        console.dir(localStorage.getItem("ProductId"))
        setCount(0)
        setBasketItemId(General.GuidEmpty())
        var RequestOptions = {
            data: {
            },
            url: General.ApiRoute() + "/Basket/Basket_GetByCustomerId",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json',
                "CustomerId": localStorage.getItem("CustomerFarmAsanId")

            }
        }
        // trackPromise(
        axios(RequestOptions)
            .then(function (result) {
                for (var i = 0; i < result.data.children.length; i++) {

                    if (result.data.children[i].productId == localStorage.getItem("ProductId")) {
                        setCount(result.data.children[i].count)
                        setBasketItemId(result.data.children[i].id)
                    }
                }




            }).catch((error) => {
                toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
            })
        // )

    }


    const GetProduct = (GetAsFirst = true) => {
        fetch(General.ApiRoute() + '/Product/GetByIdForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'Id': localStorage.getItem("ProductId")
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                document.title = result.title;
                console.dir(result)
                setPProduct(result.title);
                setPGroup(result.groupTitle);
                setPParent(result.parentTitle);
                setPhotoTag(result.photoTag);
                setIdentityNo(result.identityNo);
                setSRIID(result.storeRoomInventoryId);
                setGroupId(result.productGroupId);
                setParentId(result.productGroupParentId);
                setBrandId(result.brandId);
                setPower(result.power);
                setCurrent(result.current);
                setBrand(result.brandTitle)
                setProductType(result.productType)
                setPrice(result.lastPrice);
                setUnit(result.unit);
                setHasCatalog(result.hasCatalog == 0 ? false : true);
                setSaleType(result.saleType);
                setComment(result.comment);
                setSaleCount(result.saleCount)
                setPhotoList(result.photos);
                setFinalPrice(result.finalPrice);
                setDiscount(result.discount)
                setseoTitle("خرید " + result.groupTitle + " - " + result.title + "| فارم آسان (FarmAsan) قیمت و مشخصات |")
                // setseoDescription(result.metaDescription == "" || result.metaDescription == null ? result.comment : result.metaDescription)
                setseoDescription((
                    result.metaDescription == "" || result.metaDescription == null
                        ? result.comment
                        : result.metaDescription
                )
                    ?.replace(/<[^>]*>/g, "")
                    .trim());

                if (result.photos.length > 0)
                    setPhotoURLName(result.photos[0].photoURLName)
                if (GetAsFirst == true) {
                    GetRelativeByGroup(result.productGroupId)
                    GetRelativeByBrand(result.brandId)
                }
                var parent = General.toSlug(result.parentTitle, { latin: true })
                var group = General.toSlug(result.groupTitle, { latin: true })
                var product = General.toSlug(result.title, { latin: true })
                var NewGroup = group != parent ? group.replace(parent, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") : group;
                var Newproduct = product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") == "" ? product :
                    product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "");
                setParentURL(parent)
                setGroupURL(NewGroup)

                setCanonical('ProductInfo/' + parent + "/" + NewGroup + "/" + Newproduct)

                setProductSchema({
                    "@context": "https://schema.org",
                    "@type": "Product",

                    "name": result.title,

                    "image": result.photos?.length > 0
                        ? result.photos.map(photo =>
                            General.ApiPhotoRoute() +
                            'Content/Images/Product/Photo/' +
                            photo.photoURLName
                        )
                        : [],

                    "description": (
                        result.metaDescription ||
                        result.comment ||
                        ""
                    ).replace(/<[^>]*>/g, ""),

                    "brand": {
                        "@type": "Brand",
                        "name": result.brandTitle
                    },

                    "sku": String(result.identityNo),

                    "offers": {
                        "@type": "Offer",

                        "url": window.location.href,

                        "priceCurrency": "IRR",

                        "price": Number(
                            result.discount != 0
                                ? result.finalPrice
                                : result.lastPrice
                        ),

                        "availability":
                            result.saleCount > 0 && result.saleType == 1
                                ? "https://schema.org/InStock"
                                : "https://schema.org/OutOfStock"
                    }
                });

                var productUrl =
                    General.SiteRoute() +
                    'ProductInfo/' +
                    parent +
                    '/' +
                    NewGroup +
                    '/' +
                    Newproduct;

                var breadcrumbItems = [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "خانه",
                        "item": General.SiteRoute()
                    }
                ];

                if (localStorage.getItem("ByBrand") == "true") {

                    breadcrumbItems.push({
                        "@type": "ListItem",
                        "position": 2,
                        "name": result.brandTitle,
                        "item":
                            General.SiteRoute() +
                            'ProductBrand/' +
                            General.toSlug(result.brandTitle, { latin: true }) +
                            '/' +
                            result.brandId
                    });

                }
                else if (
                    localStorage.getItem("BySuggestion") == "true"
                ) {

                    breadcrumbItems.push({
                        "@type": "ListItem",
                        "position": 2,
                        "name": "پیشنهاد موتوربرق",
                        "item": General.SiteRoute() + 'MotorSuggestion'
                    });

                }
                else if (
                    localStorage.getItem("ByCompare") == "true"
                ) {

                    breadcrumbItems.push({
                        "@type": "ListItem",
                        "position": 2,
                        "name": "مقایسه محصولات",
                        "item": General.SiteRoute() + 'CompareProduct'
                    });

                }
                else {

                    breadcrumbItems.push(
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": result.parentTitle,
                            "item":
                                General.SiteRoute() +
                                'Group/' +
                                parent +
                                '/' +
                                result.productGroupParentId
                        },
                        {
                            "@type": "ListItem",
                            "position": 3,
                            "name": result.groupTitle,
                            "item":
                                General.SiteRoute() +
                                'Product/' +
                                parent +
                                '/' +
                                NewGroup +
                                '/' +
                                result.productGroupParentId +
                                '/' +
                                result.productGroupId
                        }
                    );

                }

                breadcrumbItems.push({
                    "@type": "ListItem",
                    "position": breadcrumbItems.length + 1,
                    "name": result.title,
                    "item": productUrl
                });

                setBreadcrumbSchema({
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                    "itemListElement": breadcrumbItems
                });
            })

    }

    const GetProductProperty = () => {
        fetch(General.ApiRoute() + '/ProductProperty/GetByProductIdForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'ProductId': localStorage.getItem("ProductId"),
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                var tmp = []
                console.dir(result);

                for (var i = 0; i < result.length; i++) {
                    tmp.push({
                        row: i + 1,
                        Id: result[i].id,
                        Title: result[i].title,
                        Comment: result[i].comment,
                        ProductId: result[i].productId,
                        PGPropertyId: result[i].pGpropertyId,
                        Order: result[i].order,

                    })
                }
                setPropertyList(tmp)
            })

    }

    const GetRelativeByGroup = (groupId) => {
        fetch(General.ApiRoute() + '/Product/GetRelative', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'BrandId': -1,
                'ProductGroupId': groupId,
                'ProductGroupParentId': -1,
                'Title': "",
                'WebIsActive': 1,
                'IsActive': -1
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                var tmp = []

                var checkingLen = isMobile ? 15 : 20;

                var result = result.length > 0 ? result.filter(x => x.id != Id) : [];
                if (isMobile) {
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Id: result[i].id,
                            LastPrice: PN.sliceNumber(result[i].lastPrice),
                            WebIsActive: result[i].webIsActive,
                            IsActive: result[i].isActive,
                            Title: result[i].title.length <= checkingLen ? result[i].title : result[i].title.substring(0, checkingLen) + '...',
                            FullTitle: result[i].title,
                            ParentTitle: result[i].parentTitle,
                            GroupTitle: result[i].groupTitle,
                            BrandTitle: result[i].brandTitle,
                            IdentityNo: result[i].identityNo,
                            PhotoTag: result[i].photoTag,
                            HasCatalog: result[i].hasCatalog,
                            SaleCount: result[i].saleCount,
                            SaleType: result[i].saleType,
                            Power: result[i].power,
                            Current: result[i].current,
                            SaleCount: result[i].saleCount * 1,
                            PhotoUrl: result[i].photos.length > 0 ? General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result[i].photos[0].photoURLName : '',

                        })
                    }
                }
                else {
                    var InnerItemCount = result.length / 4;
                    for (let index = 0; index < InnerItemCount; index++) {
                        tmp.push({ Items: [] })
                    }
                    var InnerIndex = 0;
                    for (let index = 0; index < InnerItemCount; index++) {
                        for (var i = InnerIndex; i < (index + 1) * 4; i++) {
                            if (i < result.length) {

                                tmp[index].Items.push({
                                    Id: result[i].id,
                                    LastPrice: result[i].lastPrice,
                                    WebIsActive: result[i].webIsActive,
                                    IsActive: result[i].isActive,
                                    Title: result[i].title.length <= checkingLen ? result[i].title : result[i].title.substring(0, checkingLen) + '...',
                                    FullTitle: result[i].title,
                                    ParentTitle: result[i].parentTitle,
                                    GroupTitle: result[i].groupTitle,
                                    ParentId: result[i].productGroupParentId,
                                    GroupId: result[i].productGroupId,
                                    BrandTitle: result[i].brandTitle,
                                    IdentityNo: result[i].identityNo,
                                    PhotoTag: result[i].photoTag,
                                    HasCatalog: result[i].hasCatalog,
                                    SaleType: result[i].saleType,
                                    SaleCount: result[i].saleCount,
                                    Power: result[i].power,
                                    Current: result[i].current,
                                    PhotoUrl: result[i].photos.length > 0 ? General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result[i].photos[0].photoURLName : '',
                                })
                            }
                        }
                        InnerIndex = InnerIndex + 4;
                    }
                }
                setGroupRelativeList(tmp)
            })

    }

    const GetRelativeByBrand = (brandId) => {
        fetch(General.ApiRoute() + '/Product/GetRelative', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'BrandId': brandId,
                'ProductGroupId': -1,
                'ProductGroupParentId': -1,
                'Title': "",
                'WebIsActive': 1,
                'IsActive': -1
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                var tmp = []

                var checkingLen = isMobile ? 15 : 20;

                var result = result.length > 0 ? result.filter(x => x.id != Id) : [];
                if (isMobile) {
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Id: result[i].id,
                            LastPrice: PN.sliceNumber(result[i].lastPrice),
                            WebIsActive: result[i].webIsActive,
                            IsActive: result[i].isActive,
                            Title: result[i].title.length <= checkingLen ? result[i].title : result[i].title.substring(0, checkingLen) + '...',
                            FullTitle: result[i].title,
                            ParentTitle: result[i].parentTitle,
                            GroupTitle: result[i].groupTitle,
                            BrandTitle: result[i].brandTitle,
                            IdentityNo: result[i].identityNo,
                            PhotoTag: result[i].photoTag,
                            HasCatalog: result[i].hasCatalog,
                            SaleCount: result[i].saleCount,
                            SaleType: result[i].saleType,
                            Power: result[i].power,
                            Current: result[i].current,
                            SaleCount: result[i].saleCount * 1,
                            PhotoUrl: result[i].photos.length > 0 ? General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result[i].photos[0].photoURLName : '',

                        })
                    }
                }
                else {
                    var InnerItemCount = result.length / 4;
                    for (let index = 0; index < InnerItemCount; index++) {
                        tmp.push({ Items: [] })
                    }
                    var InnerIndex = 0;
                    for (let index = 0; index < InnerItemCount; index++) {
                        for (var i = InnerIndex; i < (index + 1) * 4; i++) {
                            if (i < result.length) {

                                tmp[index].Items.push({
                                    Id: result[i].id,
                                    LastPrice: result[i].lastPrice,
                                    WebIsActive: result[i].webIsActive,
                                    IsActive: result[i].isActive,
                                    Title: result[i].title.length <= checkingLen ? result[i].title : result[i].title.substring(0, checkingLen) + '...',
                                    FullTitle: result[i].title,

                                    ParentTitle: result[i].parentTitle,
                                    GroupTitle: result[i].groupTitle,
                                    ParentId: result[i].productGroupParentId,
                                    GroupId: result[i].productGroupId,
                                    BrandTitle: result[i].brandTitle,
                                    IdentityNo: result[i].identityNo,
                                    PhotoTag: result[i].photoTag,
                                    HasCatalog: result[i].hasCatalog,
                                    SaleType: result[i].saleType,
                                    SaleCount: result[i].saleCount,
                                    Power: result[i].power,
                                    Current: result[i].current,
                                    PhotoUrl: result[i].photos.length > 0 ? General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result[i].photos[0].photoURLName : '',
                                })
                            }
                        }
                        InnerIndex = InnerIndex + 4;
                    }
                }
                setBrandRelativeList(tmp)
            })


    }

    const ShowProduct = (title, Id, innerParent, innerGroup) => {
        localStorage.setItem("ProductId", Id);

        var parent = General.toSlug(innerParent, { latin: true })
        var group = General.toSlug(innerGroup, { latin: true })
        var product = General.toSlug(title, { latin: true })
        var NewGroup = group != parent ? group.replace(parent, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") : group;
        var Newproduct = product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") == "" ? product :
            product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "");
        window.location.href = '/ProductInfo/' + parent + "/" + NewGroup + "/" + Newproduct;



    }

    const TestAI = () => {

        var request = {
            productId: localStorage.getItem("ProductId"),
            question: "این محصول برای چه کاری مناسب است؟"
        };

        fetch(General.ApiRoute() + "/AI/Ask", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request)
        })
            .then(response => response.json())
            .then(result => {
                console.log("AI RESULT:", result);
            })
            .catch(error => {
                console.error("AI ERROR:", error);
            });
    };


    //#endregion
    React.useEffect(() => {

        BindBasket();
        GetProduct(true);
        GetProductProperty();
        window.scroll({
            top: 0,
        });
    }, [])


    return (
        <Layout>
            {PProduct && (
                <Helmet>
                    <title>{seoTitle}</title>

                    <meta
                        name="description"
                        content={seoDescription}
                    />

                    <link
                        rel="canonical"
                        href={General.SiteRoute() + Canonical}
                    />

                    {ProductSchema && (
                        <script type="application/ld+json">
                            {JSON.stringify(ProductSchema)}
                        </script>
                    )}

                    {BreadcrumbSchema && (
                        <script type="application/ld+json">
                            {JSON.stringify(BreadcrumbSchema)}
                        </script>
                    )}
                </Helmet>
            )}

            {console.dir(General.SiteRoute() + Canonical)}
            <div className="ProductInfoBanner">
                <h1 >

                    {PGroup} - {PProduct}  ({Brand})
                </h1>
            </div>

            <h1 className="ProductInfoAddressBar ">
                <rsuite.Breadcrumb >
                    <rsuite.Breadcrumb.Item style={{ fontSize: "13px" }} href="/">
                        خانه
                    </rsuite.Breadcrumb.Item>
                    {localStorage.getItem("ByBrand") == "true" ?
                        <rsuite.Breadcrumb.Item style={{ fontSize: "13px" }}
                            href={'/ProductBrand/' + General.toSlug(Brand, { latin: true }) + "/" + BrandId}>
                            {Brand}
                        </rsuite.Breadcrumb.Item>
                        : localStorage.getItem("ByBrand") == "false" && localStorage.getItem("BySuggestion") == "false" && localStorage.getItem("ByCompare") == "false" ?
                            <>
                                <rsuite.Breadcrumb.Item style={{ fontSize: "13px" }}
                                    href={"/Group/" + ParentURL + "/" + ParentId}>
                                    {PParent}
                                </rsuite.Breadcrumb.Item>
                                <rsuite.Breadcrumb.Item style={{ fontSize: "13px" }}
                                    href={'/Product/' + ParentURL + "/" + GroupURL + "/" + ParentId + "/" + GroupId}>
                                    {PGroup}
                                </rsuite.Breadcrumb.Item>
                            </>
                            : localStorage.getItem("BySuggestion") == "true" ?
                                <rsuite.Breadcrumb.Item style={{ fontSize: "13px" }}
                                    href={'/MotorSuggestion'}>
                                    پیشنهاد موتوربرق
                                </rsuite.Breadcrumb.Item>
                                :
                                <rsuite.Breadcrumb.Item style={{ fontSize: "13px" }}
                                    href={'/CompareProduct'}>
                                    مقایسه محصولات
                                </rsuite.Breadcrumb.Item>


                    }
                    <rsuite.Breadcrumb.Item style={{ color: '#3b6682', fontSize: "13px" }}>{PProduct}</rsuite.Breadcrumb.Item>

                </rsuite.Breadcrumb>

            </h1>


            <rsuite.Grid className="pt-3 mb-3" >
                <rsuite.Row className="justify-content-center p-2 align-items-center">
                    {/* <rsuite.Button onClick={TestAI}>
                        تست هوش مصنوعی
                    </rsuite.Button> */}
                    <rsuite.Col xs={24}>
                        <p className={Comment != "" ? "mb-4 pb-2 " : "hide"}>
                            <Interweave content={Comment} />
                        </p>
                    </rsuite.Col>
                    <rsuite.Col xs={24} sm={24} md={12} className="mt-3" >
                        <div className="shadow p-3 me-2 ms-2 bg-body rounded w-100p h-50vh">

                            <rsuite.Image
                                src={General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + PhotoURLName}
                                fallbackSrc="../../../../assets/images/ProductGroupPrefer.jpg"
                                alt={PGroup + PProduct + "(" + Brand + ")"}
                                placeholder={<img src="../../../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '38vh' }} />
                                }
                                style={{ width: '100%', height: '38vh' }}
                                className="border-radius-half"
                                zoomed
                            />
                            <rsuite.Row className="justify-content-center align-items-center pt-2">
                                {PhotoList.map((photo) =>
                                    <rsuite.Col xs={4} sm={4} md={4} className="m-0">
                                        <rsuite.Image
                                            src={General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + photo.photoURLName}
                                            fallbackSrc="../../../../assets/images/ProductGroupPrefer.jpg"
                                            alt={PhotoTag}
                                            // placeholder={<img src="../../../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: 'auto' }} />
                                            // }
                                            style={{ width: '100%', height: 'auto' }}
                                            className="border-radius-half Cursor"
                                            onClick={() => setPhotoURLName(photo.photoURLName)}
                                        />
                                    </rsuite.Col>
                                )}
                            </rsuite.Row>
                        </div>


                    </rsuite.Col>
                    <rsuite.Col xs={24} sm={24} md={12} className="mt-3" >
                        <div className={isBrowser ? "shadow p-3 me-2 ms-2 bg-body rounded w-100p h-50vh" : "shadow p-3 me-2 ms-2 bg-body rounded w-100p"}>
                            <h2 className={isBrowser ? "mt-4  FarmAsan-text Font17" : "mt-1 FarmAsan-text  Font13"}>
                                {PProduct}
                            </h2>
                            <p className={isBrowser ? "mt-1 Font14" : "mt-1 Font13"}>
                                <b>برند </b> {Brand}
                            </p>

                            <p className={ProductType == 1 || ProductType == 2 ? isBrowser ? "mt-4 Font14" : "mt-1 Font13" : "hide"}>
                                <b>توان واقعی </b> {Power} (کیلووات KW)
                            </p>
                            <p className={ProductType == 1 ? isBrowser ? "mt-4 Font14" : "mt-1 Font13" : "hide"}>
                                <b>جریان </b> {Current} (آمپر A)
                            </p>
                            <br className={ProductType == 0 ? "" : "hide"} />
                            <br className={ProductType == 2 ? "" : "hide"} />


                            {SaleType != 3 ?
                                <p className="Font14 mt-4"><b>قیمت </b> <span className={Discount != 0 ? ' Font14  text-decoration-line-through' : "Font14  "} > {PN.sliceNumber(Price)}</span>  ریال     &nbsp;&nbsp;&nbsp;<rsuite.Badge color="green" className={Discount != 0 ? "" : "hide"} content={Discount + '%'}></rsuite.Badge></p>

                                :

                                <p className="fw-bold text-danger pt-1">قیمت در حال به روزرسانی </p>

                            }
                            <p className={Discount != 0 ? 'Font14 fw-bold text-success mt-4' : "hide"} ><b>قیمت نهایی </b>{PN.sliceNumber(FinalPrice)} ریال</p>
                            <p className={HasCatalog ? ' text-decoration-underline Font14' : "hide"}><a target="_blank" className="link-primary " href={General.ApiPhotoRoute() + 'Content/Images/Product/Catalog/' + Id + "" + PhotoTag + "_Catalog.PDF"}> دانلود کاتالوگ</a></p>

                            {SaleCount > 0 && SaleType == 1 ?
                                <p className='Font14 fw-bold text-success mt-4' > <rsuite.Image src="../../../../assets/images/weareopen.png" style={{ width: '40px', height: '40px' }} /><b>قابل فروش  </b></p>
                                : SaleCount == 0 && SaleType == 1 ?
                                    <p className='Font14 fw-bold text-danger mt-4' > <rsuite.Image src="../../../../assets/images/soldoutstamp.png" style={{ width: '40px', height: '40px' }} /><b> اتمام موجودی </b></p>

                                    : SaleType == 2 ?
                                        <p className='Font14 fw-bold text-info mt-4' > <rsuite.Image src="../../../../assets/images/reservation.jpg" style={{ width: '40px', height: '40px' }} /><b>قابل رزرو می باشد </b> </p>

                                        : SaleType == 3 ?
                                            <p className='Font14 fw-bold text-danger mt-4' > <rsuite.Image src="../../../../assets/images/CloseBoard.png" style={{ width: '40px', height: '40px' }} /><b> فروش بسته می باشد </b></p>

                                            :
                                            <></>
                            }


                            <rsuite.Row className={isBrowser ? "mt-3" : "mt-2"}>

                                <rsuite.Col xs={24} className="pt-1 text-start"
                                    onClick={() =>
                                        setTimeout(() => {
                                            BindBasket();
                                            GetProduct(false);
                                        }, 1000)

                                    }>
                                    <AddBasketItem className={Count == 0 ? "single" : ""} value={Id + "|" + PProduct + "|1|" + SRIID + "|" + Price + "|" + SaleType + "|" + Count + "|" + BasketItemId} disabled={(SaleCount > 0 && SaleType == 1) || SaleType == 2 ? false : true} />

                                </rsuite.Col>
                            </rsuite.Row>
                        </div>
                    </rsuite.Col>

                </rsuite.Row>
                <rsuite.Row className={PropertyList.length > 0 ? "" : "hide"}>
                    <rsuite.Divider className="mt-4 pt-4">
                        <rsuite.Heading className="mb-3" level={6}>مشخصات محصول  </rsuite.Heading>
                    </rsuite.Divider>
                    <rsuite.Col xs={24}>
                        <div className=" p-3 mt-3 me-2 ms-2 bg-body rounded w-100p">
                            <rsuite.Table
                                cellBordered
                                autoHeight
                                data={PropertyList}
                                wordWrap="break-word"
                                align="start"
                            >
                                {isBrowser ?
                                    <rsuite.Table.Column width={100} fixed>
                                        <rsuite.Table.HeaderCell className="fw-bold"> #</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell className="fw-bold" dataKey="row" />
                                    </rsuite.Table.Column>
                                    :
                                    <></>
                                }
                                <rsuite.Table.Column width={isBrowser ? 300 : 150} fixed>
                                    <rsuite.Table.HeaderCell className="fw-bold"> عنوان</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey="Title" className="fw-bold" />
                                </rsuite.Table.Column>
                                <rsuite.Table.Column flexGrow fixed>
                                    <rsuite.Table.HeaderCell className="fw-bold"> توضیحات</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey="Comment" />
                                </rsuite.Table.Column>
                            </rsuite.Table>
                        </div>
                    </rsuite.Col>
                </rsuite.Row>

                <rsuite.Row className={GroupRelativeList.length > 0 ? "" : "hide"}>
                    <rsuite.Divider className="mt-4 pt-4">
                        <rsuite.Heading className="mb-3" level={6}>سایر {PGroup}  </rsuite.Heading>
                    </rsuite.Divider>
                    {isBrowser ?
                        <BrowserView>
                            <rsuite.Col xs={24} sm={24} md={24} className='p-4'>
                                <Carousel className='m-3' nextLabel="" variant="dark" prevLabel="" pause="hover"  >

                                    {GroupRelativeList.map(Item => (
                                        <Carousel.Item className='bg-back'>
                                            {Item.Items.map(inner =>

                                                <rsuite.Col xs={6} className='p-1'>

                                                    <rsuite.Panel onClick={() => ShowProduct(inner.FullTitle, inner.Id, inner.ParentTitle, inner.GroupTitle)} className='shadow-sm bg-white Cursor ' bodyFill style={{ width: "100%", height: "50vh" }}>


                                                        <rsuite.Image
                                                            src={inner.PhotoUrl}
                                                            fallbackSrc="../../../../assets/images/ProductPrefer.jpg"
                                                            alt={inner.Title}
                                                            // placeholder={<img src="../../../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '30vh' }} />}

                                                            style={{ width: '100%', height: '30vh' }}
                                                        />

                                                        <rsuite.Panel >

                                                            <p>

                                                                <rsuite.Heading level={6}>{inner.Title}</rsuite.Heading>
                                                                <p className='mt-2  Font12'>برند : {inner.BrandTitle}</p>
                                                                <p className='text-start fw-bold' >{PN.sliceNumber(inner.LastPrice)} ریال</p>
                                                            </p>
                                                            <rsuite.TagGroup >
                                                                {inner.SaleCount > 0 && inner.SaleType == 1 ?
                                                                    // <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/weareopen.png" style={{ width: '40px', height: '40px' }} /><b>موجودی </b> {inner.SaleCount}</rsuite.Tag>
                                                                    <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/weareopen.png" style={{ width: '40px', height: '40px' }} /><b>قابل فروش </b> </rsuite.Tag>

                                                                    : inner.SaleCount == 0 && inner.SaleType == 1 ?
                                                                        <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/soldoutstamp.png" style={{ width: '40px', height: '40px' }} />  اتمام موجودی</rsuite.Tag>
                                                                        : inner.SaleType == 2 ?
                                                                            <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/reservation.jpg" style={{ width: '30px', height: '40px' }}></rsuite.Image>     قابل رزرو می باشد</rsuite.Tag>
                                                                            : inner.SaleType == 3 ?
                                                                                <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/CloseBoard.png" style={{ width: '30px', height: '40px' }} />فروش بسته می باشد</rsuite.Tag>
                                                                                :
                                                                                <></>
                                                                }

                                                            </rsuite.TagGroup>
                                                            {/* <div>
                                                                <rsuite.Button color="green" disabled={(inner.SaleCount > 0 && inner.SaleType == 1) || inner.SaleType == 2 ? false : true} appearance="primary" >  اضافه به سبد خرید </rsuite.Button>

                                                            </div> */}
                                                        </rsuite.Panel>
                                                    </rsuite.Panel>

                                                </rsuite.Col>
                                            )}

                                        </Carousel.Item>



                                    ))}
                                </Carousel>
                            </rsuite.Col>
                        </BrowserView>
                        :
                        <MobileView>


                            <rsuite.Col xs={24} sm={24} md={18} className='pe-4 ps-4'>
                                <Carousel className='m-3' nextLabel="" variant="dark" prevLabel="" pause="hover"  >

                                    {GroupRelativeList.map(inner => (
                                        <Carousel.Item style={{ backgroundColor: "#cddbc2" }}>

                                            <rsuite.Panel onClick={() => ShowProduct(inner.FullTitle, inner.Id, inner.ParentTitle, inner.GroupTitle)} className='shadow-sm bg-white Cursor ' bodyFill style={{ width: "100%", height: "40vh" }}>


                                                <rsuite.Image
                                                    src={inner.PhotoUrl}
                                                    fallbackSrc="../../../../assets/images/ProductPrefer.jpg"
                                                    alt={inner.Title}
                                                    // placeholder={<img src="../../../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '20vh' }} />}

                                                    style={{ width: '100%', height: '20vh' }}
                                                />

                                                <rsuite.Panel >



                                                    <rsuite.Heading level={7}>{inner.Title}</rsuite.Heading>
                                                    <p className='mt-1  Font11'>برند : {inner.BrandTitle}</p>
                                                    <p className='text-start'>

                                                        <small className='mt-1 text-start fw-bold ' > {PN.sliceNumber(inner.LastPrice)} ریال</small>

                                                    </p>
                                                    <rsuite.TagGroup >
                                                        {inner.SaleCount > 0 && inner.SaleType == 1 ?
                                                            <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/weareopen.png" style={{ width: '40px', height: '40px' }} /><b>موجودی </b> {inner.SaleCount}</rsuite.Tag>

                                                            : inner.SaleCount == 0 && inner.SaleType == 1 ?
                                                                <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/soldoutstamp.png" style={{ width: '40px', height: '40px' }} />  اتمام موجودی</rsuite.Tag>
                                                                : inner.SaleType == 2 ?
                                                                    <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/reservation.jpg" style={{ width: '30px', height: '40px' }}></rsuite.Image>     قابل رزرو می باشد</rsuite.Tag>
                                                                    : inner.SaleType == 3 ?
                                                                        <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/CloseBoard.png" style={{ width: '30px', height: '40px' }} />فروش بسته می باشد</rsuite.Tag>
                                                                        :
                                                                        <></>
                                                        }

                                                    </rsuite.TagGroup>
                                                </rsuite.Panel>
                                            </rsuite.Panel>


                                        </Carousel.Item>



                                    ))}
                                </Carousel>

                            </rsuite.Col>

                        </MobileView>
                    }
                </rsuite.Row>

                <rsuite.Row className={BrandRelativeList.length > 0 ? "" : "hide"}>
                    <rsuite.Divider className="mt-4 pt-4">
                        <rsuite.Heading className="mb-3" level={6}>سایر محصولات برند {Brand}   </rsuite.Heading>
                    </rsuite.Divider>
                    {isBrowser ?
                        <BrowserView>
                            <rsuite.Col xs={24} sm={24} md={24} className='p-4'>
                                <Carousel className='m-3' nextLabel="" variant="dark" prevLabel="" pause="hover"  >

                                    {BrandRelativeList.map(Item => (
                                        <Carousel.Item className='bg-back'>
                                            {Item.Items.map(inner =>

                                                <rsuite.Col xs={6} className='p-1'>

                                                    <rsuite.Panel onClick={() => ShowProduct(inner.FullTitle, inner.Id, inner.ParentTitle, inner.GroupTitle)} className='shadow-sm bg-white Cursor ' bodyFill style={{ width: "100%", height: "50vh" }}>


                                                        <rsuite.Image
                                                            src={inner.PhotoUrl}
                                                            fallbackSrc="../../../../assets/images/ProductPrefer.jpg"
                                                            alt={inner.Title}
                                                            // placeholder={<img src="../../../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '30vh' }} />}

                                                            style={{ width: '100%', height: '30vh' }}
                                                        />

                                                        <rsuite.Panel >

                                                            <p>

                                                                <rsuite.Heading level={6}>{inner.Title}</rsuite.Heading>
                                                                <p className='mt-2  Font12'>برند : {inner.BrandTitle}</p>
                                                                <p className='text-start fw-bold' >{PN.sliceNumber(inner.LastPrice)} ریال</p>
                                                            </p>
                                                            <rsuite.TagGroup >
                                                                {inner.SaleCount > 0 && inner.SaleType == 1 ?
                                                                    <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/weareopen.png" style={{ width: '40px', height: '40px' }} /><b>موجودی </b> {inner.SaleCount}</rsuite.Tag>

                                                                    : inner.SaleCount == 0 && inner.SaleType == 1 ?
                                                                        <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/soldoutstamp.png" style={{ width: '40px', height: '40px' }} />  اتمام موجودی</rsuite.Tag>
                                                                        : inner.SaleType == 2 ?
                                                                            <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/reservation.jpg" style={{ width: '30px', height: '40px' }}></rsuite.Image>     قابل رزرو می باشد</rsuite.Tag>
                                                                            : inner.SaleType == 3 ?
                                                                                <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/CloseBoard.png" style={{ width: '30px', height: '40px' }} />فروش بسته می باشد</rsuite.Tag>
                                                                                :
                                                                                <></>
                                                                }

                                                            </rsuite.TagGroup>
                                                            {/* <div>
                                                                <rsuite.Button color="green" disabled={(inner.SaleCount > 0 && inner.SaleType == 1) || inner.SaleType == 2 ? false : true} appearance="primary" >  اضافه به سبد خرید </rsuite.Button>

                                                            </div> */}
                                                        </rsuite.Panel>
                                                    </rsuite.Panel>

                                                </rsuite.Col>
                                            )}

                                        </Carousel.Item>



                                    ))}
                                </Carousel>
                            </rsuite.Col>
                        </BrowserView>
                        :
                        <MobileView>


                            <rsuite.Col xs={24} sm={24} md={18} className='pe-4 ps-4'>
                                <Carousel className='m-3' nextLabel="" variant="dark" prevLabel="" pause="hover"  >

                                    {BrandRelativeList.map(inner => (
                                        <Carousel.Item style={{ backgroundColor: "#cddbc2" }}>

                                            <rsuite.Panel onClick={() => ShowProduct(inner.FullTitle, inner.Id, inner.ParentTitle, inner.GroupTitle)} className='shadow-sm bg-white Cursor ' bodyFill style={{ width: "100%", height: "40vh" }}>


                                                <rsuite.Image
                                                    src={inner.PhotoUrl}
                                                    fallbackSrc="../../../../assets/images/ProductPrefer.jpg"
                                                    alt={inner.Title}
                                                    placeholder={<img src="../../../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '20vh' }} />}

                                                    style={{ width: '100%', height: '20vh' }}
                                                />

                                                <rsuite.Panel >



                                                    <rsuite.Heading level={7}>{inner.Title}</rsuite.Heading>
                                                    <p className='mt-1  Font11'>برند : {inner.BrandTitle}</p>
                                                    <p className='text-start'>

                                                        <small className='mt-1 text-start fw-bold ' > {PN.sliceNumber(inner.LastPrice)} ریال</small>

                                                    </p>
                                                    <rsuite.TagGroup >
                                                        {inner.SaleCount > 0 && inner.SaleType == 1 ?
                                                            <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/weareopen.png" style={{ width: '40px', height: '40px' }} /><b>موجودی </b> {inner.SaleCount}</rsuite.Tag>

                                                            : inner.SaleCount == 0 && inner.SaleType == 1 ?
                                                                <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/soldoutstamp.png" style={{ width: '40px', height: '40px' }} />  اتمام موجودی</rsuite.Tag>
                                                                : inner.SaleType == 2 ?
                                                                    <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/reservation.jpg" style={{ width: '30px', height: '40px' }}></rsuite.Image>     قابل رزرو می باشد</rsuite.Tag>
                                                                    : inner.SaleType == 3 ?
                                                                        <rsuite.Tag className="w-100p" size="sm"><rsuite.Image src="../../../../assets/images/CloseBoard.png" style={{ width: '30px', height: '40px' }} />فروش بسته می باشد</rsuite.Tag>
                                                                        :
                                                                        <></>
                                                        }

                                                    </rsuite.TagGroup>
                                                </rsuite.Panel>
                                            </rsuite.Panel>


                                        </Carousel.Item>



                                    ))}
                                </Carousel>

                            </rsuite.Col>

                        </MobileView>
                    }
                </rsuite.Row>



            </rsuite.Grid>


        </Layout >
    )
}

export default ProductInfo;